import MarkinhosLogo from '../assets/Markinhos-perfil.png'; // Caminho relativo ao diretório node_modules/
import './three.css';
import React, { useEffect } from 'react';
import NovaImagem from '../assets/Markinhos-perfil.png';


function StarIcon() {
    return (
        <i class='bx bxs-star starIcon'></i>
    )
}

function InstaIcon() {
    return (
        <i class='bx bxl-instagram-alt icon'></i>
    )
}

function TikTokIcon(){
    return(
        <i class='bx bxl-tiktok icon' ></i>
    )
}

function MessageIcon(){
    return(
        <i class='bx bxs-message-dots icon'></i>
    )
}

function YoutubeIcon(){
    return(
        <i class='bx bxl-youtube icon' ></i>
    )
}

function ThreeLink() {
    document.querySelectorAll('.linksContainer').forEach(container => {
        container.addEventListener('click', () => {
            const link = container.querySelector('.links');
            if (link) {
                window.open(link.href, '_blank');
            }
        });
    });

    document.title = "Markinhos | Links"

     useEffect(() => {
        const favicon = document.querySelector('link[rel="icon"]');
        if (favicon) {
            favicon.href = NovaImagem;
        }
    }, [])
    
    return (
        <div className='threeLinkPage'>
            <div className='threeLinkPage'>
                <main className='threeLinkContainer'>
                    <div className='threeLinkHeader'>
                        <h1 className='threeLinkTitle'>
                            Markinhos Costa
                        </h1>
                        <img src={MarkinhosLogo} alt='MarkinhosLogo' className='markinhosLogo' />
                    </div>
                    <ul className='ulContainer'>
                        <div className='linksContainer'>
                            <a className='links' target='blank' href='https://www.instagram.com/markinhoscosta_/'>
                                instagram
                            </a>
                            <InstaIcon />
                        </div>
                        <div className='linksContainer'>
                            <a className='links' target='blank' href='https://www.tiktok.com/@markinhoscosta5?lang=pt-BR'>
                                TikTok
                            </a>
                            <TikTokIcon />
                        </div>
                        <div className='linksContainer'>
                            <a className='links' target='blank' href='https://www.youtube.com/@marcosnewstar'>
                                YouTube
                            </a>
                            <YoutubeIcon />
                        </div>
                        <div className='linksContainer'>
                            <a className='links' target='blank' href='https://forms.gle/jw8JcVHjvAs5UJ159' >
                                Workshop-2024
                            </a>
                            <MessageIcon />
                        </div>
                    </ul>
                    <a className='footerContato' target='blank' href='https://www.instagram.com/devigaoooo/'>
                        madeBy <strong>Igaoooo</strong>
                    </a>
                </main>
            </div>
        </div>
    )
}

export default ThreeLink;
